module.exports = __webpack_public_path__ + "img/pd-img-head10.c99e372a.png";